import { useEffect, useState } from "react";
import { Store } from "../../../types";
import StoreReportHeader from "./StoreReportHeader";
import StoreReportMenu from "./StoreReportMenu";
import { useStoreSyncState } from "../useStoreSyncState";
import reportIcon from "../../../assets/management/report.svg";

type Props = {
    store: Store;
};

export default function StoreReportTab({ store }: Props) {
    const [reportStore, setReportStore] = useState(store);

    useEffect(() => {
        setReportStore(store);
    }, [store]);

    useStoreSyncState(reportStore, setReportStore);

    return (
        <div className="store-report-tab">
            <div className="store-report-tab__title">
                <p>Shopify Stores/{store.friendlyName}</p>
                <h1><img src={reportIcon} alt="" />Report</h1>
            </div>
            <StoreReportHeader store={reportStore} />
            <StoreReportMenu store={reportStore} />
        </div>
    );
}
